import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { NetworksType } from '@libs/types';
import { EthUsdtIcon, TronUsdtIcon, BscUsdtIcon, SolanaIcon, EtheriumIcon, } from '../assets';
// Restyled ICONS
const defaultSizeStyles = css `
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;
const BSCUsdtIcon = styled(BscUsdtIcon) `
  ${defaultSizeStyles}
`;
const ETHUsdtIcon = styled(EthUsdtIcon) `
  ${defaultSizeStyles}
`;
const TRONUsdtIcon = styled(TronUsdtIcon) `
  ${defaultSizeStyles}
`;
const SolanaUsdtIcon = styled(SolanaIcon) `
  ${defaultSizeStyles}
`;
const SolanaUsdcIcon = styled(SolanaIcon) `
  ${defaultSizeStyles}
`;
const EthUsdcIcon = styled(EtheriumIcon) `
  ${defaultSizeStyles}
`;
export const useNetworkIcons = (size = '4rem') => ({
    [NetworksType.USDT_BSC]: _jsx(BSCUsdtIcon, { size: size }),
    [NetworksType.USDT_ERC20]: _jsx(ETHUsdtIcon, { size: size }),
    [NetworksType.TRX_USDT_S2UZ]: _jsx(TRONUsdtIcon, { size: size }),
    [NetworksType.SOL_USDT_EWAY]: _jsx(SolanaUsdtIcon, { size: size }),
    [NetworksType.SOL_USDC_PTHX]: _jsx(SolanaUsdcIcon, { size: size }),
    [NetworksType.USDC_ETH]: _jsx(EthUsdcIcon, { size: size }),
});
export default useNetworkIcons;
//# sourceMappingURL=useNetworkIcons.js.map